import React from 'react'
import LinearProgress from '@mui/material/LinearProgress'
import { useSelector } from 'react-redux'
import { APP_BAR_HEIGHT, READ_PROGRESS } from '../theme/tokens'

/**
 * A 2px bar under the header while any page read (a GET not marked
 * background) is in flight. It replaces the full-screen loader for reads,
 * which covered every page on every load: the page stays visible and usable,
 * and each list shows its own loading state where its rows will be.
 *
 * It never takes clicks (pointer-events none) and sits above the page, the
 * sidebar and the header, but below dialogs and menus.
 */
const ReadProgress = () => {
    const readLoading = useSelector((state) => state.app.readLoading)
    if (!readLoading) return null
    return (
        <LinearProgress
            aria-label="Loading"
            data-testid="read-progress"
            sx={{
                position: 'fixed',
                top: APP_BAR_HEIGHT,
                left: 0,
                right: 0,
                height: 2,
                borderRadius: 0,
                pointerEvents: 'none',
                // Above the header (drawer + 1) and the drawer, below the
                // modal layer (dialogs, menus, the write overlay's peers).
                zIndex: (theme) => theme.zIndex.drawer + 2,
                backgroundColor: READ_PROGRESS.track,
                '& .MuiLinearProgress-bar': {
                    backgroundColor: READ_PROGRESS.bar,
                    borderRadius: 0,
                },
            }}
        />
    )
}

export default ReadProgress
